export type InterventionEvaluationResult = 'EFFICACE' | 'PARTIELLEMENT_EFFICACE' | 'INEFFICACE';

export interface InterventionEvaluation {
    result?: InterventionEvaluationResult;
    date?: string;      // ISO
    comment?: string;
    author?: string;    // userId
}

export interface Intervention {
    id: string;
    project?: string;        // ObjectId
    trackers?: string[];     // Tracker.uuid values (NOT Mongo _id)
    category: string;        // referential key
    subType: string;         // referential key
    description?: string;
    applicant?: string;      // userId (requester)
    assignee: string;        // userId (owner)
    dueDate?: string;        // ISO — planned due date
    evaluation?: InterventionEvaluation;
    createdBy?: string;
    createdDate?: string;    // ISO
    projectName?: string;
    sourceDatabase?: string;
    assigneeName?: string;
    assigneeActive?: boolean;
    applicantName?: string;
}

export interface PostIntervention {
    project?: string;
    trackers?: string[];     // Tracker.uuid values
    category: string;
    subType: string;
    description?: string;
    applicant?: string;
    assignee: string;
    dueDate?: string;
    evaluation?: InterventionEvaluation;
}

export interface PutIntervention {
    id: string;
    project?: string;
    trackers?: string[];     // Tracker.uuid values
    category?: string;
    subType?: string;
    description?: string;
    applicant?: string;
    assignee?: string;
    dueDate?: string;
    evaluation?: InterventionEvaluation;
}

export const defaultIntervention: Partial<Intervention> = { category: '', subType: '' };
export type InterventionReferential = Record<string, string[]>;
